<template>
    <div class="variables-task-modal">
        <transition name="modal">
            <div v-if="!selectVariableModel" class="modal-mask task-modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <app-sub-navigation-bar
                            :segments="breadcrumbSegments"
                            :view-mode="catalogViewMode"
                            :is-at-root="isAtCategoryTreeRoot"
                            :task-code="taskBreadcrumbCode"
                            @navigate-all="onBreadcrumbNavigateAll"
                            @navigate-segment="onBreadcrumbNavigateSegment"
                        />

                        <div class="task-modal-shell">
                            <div class="task-modal-body">
                                <div class="task-modal-layout">
                                    <div class="task-modal-main">
                                        <h4 class="task-modal-title" v-if="!editTitle">{{ task.title }}</h4>
                                        <div class="ui form" v-else>
                                            <div class="field task-modal-title-field">
                                                <textarea rows="4" v-model="task.title"></textarea>
                                            </div>
                                        </div>
                                        <a v-if="!editTitle" class="task-modal-edit-link" @click="editTitle = true">Edit</a>
                                        <a v-else class="task-modal-edit-link" @click="editTitle = false">Save</a>

                                        <div class="task-modal-description" v-if="!editDescription">{{ task.description }}</div>
                                        <div class="ui form" v-else>
                                            <div class="field">
                                                <textarea rows="4" v-model="task.description"></textarea>
                                            </div>
                                        </div>
                                        <a v-if="!editDescription" class="task-modal-edit-link" @click="editDescription = true">Edit</a>
                                        <a v-else class="task-modal-edit-link" @click="editDescription = false">Save</a>

                                        <div class="task-modal-options">
                                            <div class="task-modal-field">
                                                <app-field-label>Quantity</app-field-label>
                                                <app-quantity-stepper
                                                    :model-value="task.qty"
                                                    :min="1"
                                                    @update:model-value="task.qty = $event"
                                                />
                                            </div>
                                            <div class="task-modal-field" v-if="!isFixedTypeTask">
                                                <app-field-label>Difficulty</app-field-label>
                                                <app-select
                                                    :defaultLabel="''"
                                                    :items="$store.getters['task/getMultipliers']"
                                                    :value="task.location"
                                                    @selected="task.location = $event.id">
                                                </app-select>
                                            </div>
                                        </div>

                                        <div v-if="hasVariableProducts">
                                            <hr class="task-modal-divider" />

                                            <h5 class="task-modal-field-label">Select product</h5>

                                            <button
                                                v-if="!hasSelectedProduct"
                                                type="button"
                                                class="task-modal-select-product"
                                                @click="selectVariable(PRODUCT_SLOT_KEY)"
                                            >
                                                <span class="task-modal-select-product__icon" aria-hidden="true">+</span>
                                                <span class="link-medium">Select a product</span>
                                            </button>

                                            <article
                                                v-if="selectedProduct"
                                                class="task-modal-selected-product"
                                            >
                                                <div class="task-modal-selected-product__image">
                                                    <img
                                                        v-if="selectedProduct.hasOwnProperty('images') && selectedProduct.images !== null"
                                                        :src="getImageUrl(selectedProduct)"
                                                        :alt="selectedProduct.description || ''"
                                                    />
                                                    <img
                                                        v-else
                                                        src="../../../../assets/img/no-image-available.jpg"
                                                        alt=""
                                                    />
                                                </div>
                                                <div class="task-modal-selected-product__body">
                                                    <h2 class="task-modal-selected-product__title text-body-large-strong">{{ displayCatalogName(selectedProduct.description) }}</h2>
                                                    <button
                                                        type="button"
                                                        class="ui secondary button task-modal-selected-product__change"
                                                        @click="selectVariable(PRODUCT_SLOT_KEY)"
                                                    >Change</button>
                                                </div>
                                            </article>
                                        </div>

                                        <hr class="task-modal-divider" />

                                        <app-task-modal-cost-summary
                                            :total-price="displayTotalCost"
                                            :product-cost="displayProductCost"
                                            :product-margin-pct="displayProductMarginPct"
                                            :gross-profit="displayGrossProfit"
                                            :gst-amount="displayGstAmount"
                                            :labour-time="displayLabourTime"
                                            :labour-rate="displayLabourRate"
                                            v-model:price-type="priceType"
                                        >
                                            <template #cta>
                                                <a
                                                    v-if="!edit"
                                                    href="#"
                                                    class="ui primary button task-modal-add-btn"
                                                    :class="{ 'disabled': addDisabled }"
                                                    @click.prevent="add"
                                                >Add to quote</a>
                                                <a
                                                    v-else
                                                    href="#"
                                                    class="ui primary button task-modal-add-btn"
                                                    :class="{ 'disabled': addDisabled }"
                                                    @click.prevent="save"
                                                >Save</a>
                                            </template>
                                        </app-task-modal-cost-summary>

                                        <div class="task-modal-compare">
                                            <app-checkbox
                                                :model-value="compareChecked"
                                                :label="compareCheckboxLabel"
                                                :disabled="compareMaxReached"
                                                @update:model-value="onCompareCheckboxInput"
                                            />
                                        </div>
                                    </div>

                                    <div class="task-modal-image">
                                        <div class="task-modal-image-frame">
                                            <img v-if="task.hasOwnProperty('images') && task.images !== null" :src="getImageUrl(task)" :alt="task.title || ''">
                                            <img v-if="!task.hasOwnProperty('images') || task.images === null" src="../../../../assets/img/no-image-available.jpg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <app-select-variable v-if="selectVariableModel"
            :parent_products="variablesModal"
            :slot-type="variablesModalType"
            :search-filters="variableSearchFilters"
            @close="selectVariableModel = false"
            @select="addVariable">
        </app-select-variable>
    </div>
</template>
<script>
  import SelectProduct from '../selectproduct/selectproduct.vue';
  import SubNavigationBar from '../../../common/SubNavigationBar.vue';
  import TaskModalCostSummary from '../common/TaskModalCostSummary.vue';
  import { grossProfit, productMarkupOnCostPercent } from '../../../../helpers/quoteMargin';
  import { bankersRound } from '../../../../helpers/quoteTotals';
  import {
    applyResolvedSellToMaterial,
    accountMarkupPctForItem,
    resolvedCatalogItemSell,
    DEFAULT_STANDARD_MARGIN_PCT
  } from '../../../../helpers/productPricing';
  import axios from 'axios';
  import {isEmpty} from '../../../../helpers/isEmpty.js';
  import compareModalMixin from '../../../../helpers/compareModalMixin';
  import { resolveTaskSellPrice, TASK_PRICE_TYPES } from '../../../../helpers/taskPricing';
  import { isFixedType } from '../../../../helpers/taskTypes';
  import { toTitleCase } from '../../../../helpers/titleCase';
  import { withNormalizedImages } from '../../../../helpers/itemImageUrl';

  export default {
    mixins: [compareModalMixin],
    components: {
        'app-select-variable': SelectProduct,
        'app-sub-navigation-bar': SubNavigationBar,
        'app-task-modal-cost-summary': TaskModalCostSummary,
    },
    computed: {
        taskBreadcrumbCode: function () {
            const task = this.task || {}
            if (task.code != null && String(task.code).trim() !== '') {
                return String(task.code).trim()
            }
            if (task.uuid != null && String(task.uuid).trim() !== '') {
                return String(task.uuid).trim()
            }
            return ''
        },
        addDisabled: function () {
            return this.hasVariableProducts && !this.hasSelectedProduct;
        },
        hasVariableProducts: function () {
            return this.variableOptions.length > 0;
        },
        /** Keep catalogue search focused on the right product family for this task. */
        variableSearchFilters: function () {
            const name = String((this.task && this.task.name) || '').toLowerCase();
            if (/closed coupled|close coupled|c\/c|\bcc\b/.test(name) && /toilet/.test(name)) {
                return ['toilet suite', 't\\/suite', 't\\/s', 'c\\/c', '\\bcc\\b', 'close couple', 'ccbtw'];
            }
            if (/linked/.test(name) && /toilet/.test(name)) {
                return ['link.*suite', 'link t\\/s', 'link t\\/suite', 'toilet suite', 'uniset'];
            }
            if (/toilet pan/.test(name)) {
                return ['\\bpan\\b'];
            }
            if (/toilet cistern/.test(name)) {
                return ['cistern'];
            }
            if (/toilet seat/.test(name)) {
                return ['toilet seat', 't\\/seat'];
            }
            if (/sink mixer|kitchen sink mixer|laundry sink mixer|install kitchen sink|install laundry sink/.test(name)) {
                return ['sink set'];
            }
            if (/vanity/.test(name)) {
                return ['vanity'];
            }
            if (/basin bowl|install basin/.test(name)) {
                return ['basin'];
            }
            if (/laundry tub/.test(name)) {
                return ['laundry tub', 'laundry sink'];
            }
            if (/\bbath\b/.test(name) || /install bath/.test(name)) {
                return ['bath'];
            }
            if (/rainwater tank/.test(name)) {
                return [
                    'rainwater tank',
                    'slimline tank',
                    'polychoice',
                    'poly water tank',
                    's/line tank',
                    'r/water tank',
                    'rural metal tank'
                ];
            }
            if (/continuous flow/.test(name)) {
                return ['hwu', 'c\\/flow', 'continuous', 'instant'];
            }
            if (/gas storage.*hot water|install gas storage/.test(name)) {
                return ['hwu', 'gas storage'];
            }
            if (/solar electric/.test(name)) {
                return ['solar', 'hiline', 'loline', 'sunmaster', 'elect'];
            }
            if (/solar gas/.test(name)) {
                return ['solar', 'booster', 'loline', 'sunmaster', 'gas storage tank'];
            }
            if (/bidet suite|install bidet/.test(name)) {
                return ['bidet'];
            }
            return [];
        },
        /** Flattened list of all variable product alternatives (one picker). */
        variableOptions: function () {
            const vars = this.variables
            if (!vars || typeof vars !== 'object') return []
            if (Array.isArray(vars)) return vars.filter(Boolean)
            const out = []
            Object.keys(vars).forEach(function (key) {
                const list = vars[key]
                if (Array.isArray(list)) {
                    list.forEach(function (item) { if (item) out.push(item) })
                }
            })
            return out
        },
        hasSelectedProduct: function () {
            return !!this.selectedProduct
        },
        selectedProduct: function () {
            const selected = this.selectedVariables || {}
            if (selected[this.PRODUCT_SLOT_KEY]) return selected[this.PRODUCT_SLOT_KEY]
            const keys = Object.keys(selected)
            return keys.length ? selected[keys[0]] : null
        },
        allProductsSelected: function () {
            if (!this.hasVariableProducts) return false;
            return this.hasSelectedProduct;
        },
        displayTotalCost: function () {
            if (this.hasVariableProducts && !this.allProductsSelected) return '-';
            return this.activePriceFormatted;
        },
        displayProductCost: function () {
            if (this.hasVariableProducts && !this.allProductsSelected) return '-';
            return this.materialBuyCost;
        },
        displayLabourTime: function () {
            if (this.hasVariableProducts && !this.allProductsSelected) return '-';
            if (this.isFixedTypeTask) {
                const hours = Number(this.task.labour_time_hours) || 0
                const minutes = Number(this.task.labour_time_minutes) || 0
                if (hours <= 0 && minutes <= 0) return '–'
            }
            return this.labourTimeHoursMinutes;
        },
        displayGrossProfit: function () {
            if (this.hasVariableProducts && !this.allProductsSelected) return '-';
            const sell = parseFloat(this.activePriceFormatted);
            const buy = parseFloat(this.materialBuyCost);
            if (!Number.isFinite(sell)) return '-';
            return grossProfit(sell, buy).toFixed(2);
        },
        displayProductMarginPct: function () {
            if (this.hasVariableProducts && !this.allProductsSelected) return '-';
            const vars = Object.values(this.selectedVariables)
            let totalBuy = 0
            let weightedMarkup = 0
            vars.forEach((variable) => {
                const buy = parseFloat(variable && variable.cost) || 0
                if (buy <= 0) return
                weightedMarkup += accountMarkupPctForItem(variable, this.standardMarginPct) * buy
                totalBuy += buy
            })
            if (totalBuy > 0) {
                return bankersRound(weightedMarkup / totalBuy, 1)
            }
            const sell = parseFloat(this.materialCost)
            const buy = parseFloat(this.materialBuyCost)
            if (!Number.isFinite(sell)) return '-'
            return productMarkupOnCostPercent(sell, buy)
        },
        displayGstAmount: function () {
            if (this.hasVariableProducts && !this.allProductsSelected) return '-';
            const sell = parseFloat(this.activePriceFormatted);
            if (!Number.isFinite(sell) || sell <= 0) return '0.00';
            return bankersRound(sell / 11, 2).toFixed(2);
        },
        displayLabourRate: function () {
            if (this.hasVariableProducts && !this.allProductsSelected) return '';
            const hourly = parseFloat(this.task.labour_hourly_rate);
            if (!Number.isFinite(hourly) || hourly <= 0) return '';
            return '$' + hourly.toFixed(2) + '/hr';
        },
        effectiveMultiplier: function () {
            return this.task.location || this.task.hourly_rate_multiplier || 1;
        },
        calculatedPrice: function () {
            const materialCost = parseFloat(this.materialCost)
            const hourlyRate = parseFloat(this.task.labour_hourly_rate)
            const hours = parseFloat(this.task.labour_time_hours)
            const minutes = parseFloat(this.task.labour_time_minutes)
            const qty = parseFloat(this.task.qty)
            const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1

            const safeHourly = Number.isFinite(hourlyRate) ? hourlyRate : 0
            const safeHours = Number.isFinite(hours) ? hours : 0
            const safeMinutes = Number.isFinite(minutes) ? minutes : 0
            const safeMaterialCost = Number.isFinite(materialCost) ? materialCost : 0

            const minuteRate = safeHourly / 60
            const totalMinutes = safeHours * 60 + safeMinutes
            const labourCost = (totalMinutes * minuteRate) * this.effectiveMultiplier * safeQty

            return (labourCost + safeMaterialCost).toFixed(2)
        },
        standardPrice: function () {
            return resolveTaskSellPrice(this.task, TASK_PRICE_TYPES.STANDARD, this.calculatedPrice)
        },
        addonPrice: function () {
            return resolveTaskSellPrice(this.task, TASK_PRICE_TYPES.ADDON, this.calculatedPrice)
        },
        activePrice: function () {
            return this.priceType === TASK_PRICE_TYPES.ADDON ? this.addonPrice : this.standardPrice
        },
        activePriceFormatted: function () {
            const n = this.activePrice
            return Number.isFinite(n) ? n.toFixed(2) : '0.00'
        },
        price: function () {
            return this.activePriceFormatted
        },
        materialCost: function () {
            let materialCost = 0
            let variableCost = 0;

            if (this.task.hasOwnProperty('materials')) {
                const defaults = (this.task.materials && this.task.materials.default) ? this.task.materials.default : []
                defaults.forEach(function (material) {
                    const sell = parseFloat(material.sell_price)
                    const qty = parseFloat(material.qty)
                    materialCost += (Number.isFinite(sell) ? sell : 0) * (Number.isFinite(qty) ? qty : 0)
                });

                const companyItems = (this.task.materials && this.task.materials.company) ? this.task.materials.company : []
                companyItems.forEach(function (material) {
                    const sell = parseFloat(material.sell_price)
                    const qty = parseFloat(material.qty)
                    materialCost += (Number.isFinite(sell) ? sell : 0) * (Number.isFinite(qty) ? qty : 0)
                });
            }


            Object.values(this.selectedVariables).forEach((variable) => {
                variableCost += resolvedCatalogItemSell(variable, this.standardMarginPct)
            });

            const qty = parseFloat(this.task.qty)
            const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1
            const cost = (materialCost + variableCost) * safeQty;

            return parseFloat(cost).toFixed(2);
        },
        materialBuyCost: function () {
            let buyCost = 0
            let variableBuyCost = 0

            if (this.task.hasOwnProperty('materials')) {
                const defaults = (this.task.materials && this.task.materials.default) ? this.task.materials.default : []
                defaults.forEach(function (material) {
                    const cost = parseFloat(material.cost)
                    const qty = parseFloat(material.qty)
                    buyCost += (Number.isFinite(cost) ? cost : 0) * (Number.isFinite(qty) ? qty : 0)
                })

                const companyItems = (this.task.materials && this.task.materials.company) ? this.task.materials.company : []
                companyItems.forEach(function (material) {
                    const cost = parseFloat(material.cost)
                    const qty = parseFloat(material.qty)
                    buyCost += (Number.isFinite(cost) ? cost : 0) * (Number.isFinite(qty) ? qty : 0)
                })
            }

            Object.values(this.selectedVariables).forEach(function (variable) {
                const cost = parseFloat(variable && variable.cost)
                variableBuyCost += Number.isFinite(cost) ? cost : 0
            })

            const qty = parseFloat(this.task.qty)
            const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1
            return parseFloat((buyCost + variableBuyCost) * safeQty).toFixed(2)
        },
        labourTimeHoursMinutes: function () {
            let totalMinutes = 0;

            totalMinutes = this.task.labour_time_hours * 60 + this.task.labour_time_minutes;
            const labourTime = (totalMinutes * this.effectiveMultiplier) * this.task.qty;

            return this.convertMinutesToHoursAndMinutes(labourTime);
        },
        isFixedTypeTask: function () {
            return isFixedType(this.task && this.task.type)
        },
    },
    watch: {
        selectedVariables: {
            deep: true,
            handler: function () {
                this.onCompareFieldsMaybeChanged()
            }
        }
    },
    data: () => {
        return {
            PRODUCT_SLOT_KEY: 'product',
            editDescription: false,
            editTitle: false,
            task: {
                location: 1,
                qty: 1,
                show_variables: true
            },
            selectVariableModel: false,
            variablesModal: [],
            variablesModalType: null,
            selectedVariables: {},
            variables: {},
            standardMarginPct: DEFAULT_STANDARD_MARGIN_PCT,
            priceType: TASK_PRICE_TYPES.STANDARD,
        };
    },
    methods: {
        isEmpty,
        displayCatalogName: function (value) {
            return toTitleCase(value)
        },
        preserveComparedVariantOnFieldChange: function () {
            return true
        },
        buildCompareFieldSignature: function () {
            const selected = Object.values(this.selectedVariables)
                .map(function (variable) {
                    if (!variable) return ''
                    return [
                        variable.type != null ? variable.type : '',
                        variable.id != null ? variable.id : '',
                        variable.uuid != null ? variable.uuid : '',
                    ].join(':')
                })
                .sort()
            return [
                this.task && this.task.title,
                this.task && this.task.description,
                this.task && this.task.qty,
                this.task && this.task.location,
                this.priceType,
                selected.join('|'),
            ].join('\u0001')
        },
        getCompareTask: function () {
            const task = Object.assign({}, this.task)
            const selected = Object.values(this.selectedVariables)
            task.variables = selected
            const withImage = selected.find((variable) => {
                if (!variable) return false
                if (Array.isArray(variable.images)) return variable.images.length > 0
                return !!variable.images
            })
            if (withImage) {
                task.images = withImage.images
            }
            return task
        },
        selectVariable: function () {
            const slotKey = this.PRODUCT_SLOT_KEY;
            this.variablesModalType = slotKey;
            this.variablesModal = this.variableOptions.slice();
            this.selectVariableModel = true;
        },
        addVariable: function (variable) {
            this.selectVariableModel = false;
            const resolved = this.resolveVariablePricing(variable);
            const slotKey = this.PRODUCT_SLOT_KEY;
            this.selectedVariables = {
                [slotKey]: Object.assign({}, resolved, { slot_type: slotKey })
            };
            this.variablesModalType = null;
        },
        loadAccountMargin: function () {
            return axios.get('/api/setting/settings').then((res) => {
                const pct = res.data && res.data.standard_margin_pct
                if (pct != null && pct !== '') {
                    this.standardMarginPct = parseFloat(pct) || DEFAULT_STANDARD_MARGIN_PCT
                }
            }).catch(() => {})
        },
        resolveVariablePricing: function (item) {
            return applyResolvedSellToMaterial(item, this.standardMarginPct)
        },
        syncVariablesCatalog: function () {
            const self = this
            const options = this.variableOptions.map(function (v) {
                return self.resolveVariablePricing(v)
            })
            this.variables = options.length ? { [this.PRODUCT_SLOT_KEY]: options } : {}
            if (this.selectedProduct) {
                this.selectedVariables = {
                    [this.PRODUCT_SLOT_KEY]: self.resolveVariablePricing(this.selectedProduct)
                }
            } else {
                this.selectedVariables = {}
            }
        },
        removeVariable: function () {
            this.selectedVariables = {}
        },
        getSupplierName: function (id) {
            if (id === null || id === undefined) return 'N/A'
            const suppliers = this.$store.getters['product/getSuppliers'] || []
            if (!Array.isArray(suppliers) || suppliers.length === 0) return 'N/A'
            const match = suppliers.find((s) => s && s.id == id)
            return match && match.name ? match.name : 'N/A'
        },
        getBrandName: function (id) {
            if (id === null) {
                return 'N/A';
            }

            const brands = this.$store.getters['product/getBrands'] || []
            if (!Array.isArray(brands) || brands.length === 0) return 'N/A'
            const match = brands.find((b) => b && b.id == id)
            return match && match.name ? match.name : 'N/A'
        },
        getTypeLabel: function (typeId) {
            if (typeId === null || typeId === undefined || typeId === '') return 'N/A'
            const s = String(typeId).trim()
            // If it's already a readable label (not numeric), show it.
            const maybeNumber = Number(s)
            if (!Number.isFinite(maybeNumber)) return s

            const types = this.$store.getters['material/getTypes'] || []
            const match = types.find((t) => {
                if (!t) return false
                return String(t.id) === s || String(t.order_id) === s
            })
            if (match && match.name) return match.name
            return s
        },
        add: function () {
            this.task.show_variables = true;
            this.task.variables = Object.values(this.selectedVariables);
            this.task.price_type = this.priceType;
            this.task.sell_price = this.activePriceFormatted;
            this.$emit('add', this.task);
        },
        save: function () {
            this.task.show_variables = true;
            this.task.variables = Object.values(this.selectedVariables);
            this.task.price_type = this.priceType;
            this.task.sell_price = this.activePriceFormatted;
            this.$emit('save', this.task);
        },
        convertMinutesToHoursAndMinutes: function (minutes) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = Math.round(minutes % 60);
            if (hours > 0 && remainingMinutes > 0) {
                return `${hours}hr ${remainingMinutes}min`;
            }
            if (hours > 0) {
                return `${hours}hr`;
            }
            return `${remainingMinutes}min`;
        },
        onBreadcrumbNavigateAll: function () {
            this.$emit('breadcrumb-navigate-all');
        },
        onBreadcrumbNavigateSegment: function (idx) {
            this.$emit('breadcrumb-navigate-segment', idx);
        }
    },
    mounted: function () {
        document.body.classList.add('no-scroll');
        this.task = Object.assign({}, this.parent_task);
        if (this.task.price_type) {
            this.priceType = this.task.price_type === TASK_PRICE_TYPES.ADDON
                ? TASK_PRICE_TYPES.ADDON
                : TASK_PRICE_TYPES.STANDARD;
        }
        if (this.task.show_variables === undefined) {
            this.$set(this.task, 'show_variables', true)
        }
        if (!this.task.location && this.task.hourly_rate_multiplier) {
            this.task.location = parseFloat(this.task.hourly_rate_multiplier);
        } else if (this.task.location) {
            this.task.location = parseFloat(this.task.location);
        }
        if (!this.task.variables) {
            this.task.variables = { default: [], company: [] };
        } else if (!Array.isArray(this.task.variables) && typeof this.task.variables === 'object') {
            if (!Array.isArray(this.task.variables.default)) this.task.variables.default = [];
            if (!Array.isArray(this.task.variables.company)) this.task.variables.company = [];
        }

        if (this.edit === true && Array.isArray(this.task.variables)) {
            const first = this.task.variables[0]
            if (first) {
                this.selectedVariables = {
                    [this.PRODUCT_SLOT_KEY]: Object.assign({}, first, { slot_type: this.PRODUCT_SLOT_KEY })
                }
            }
        }

        if (!this.task.uuid) {
            this.variables = {};
            this.loadAccountMargin();
            return;
        }
        const self = this
        Promise.all([
            this.loadAccountMargin(),
            axios.get(`/api/tasks/variables/${this.task.uuid}`)
        ]).then(function ([, response]) {
            const vars = response.data && response.data.variables
            if (vars && typeof vars === 'object') {
                self.task.variables = {
                    default: Array.isArray(vars.default) ? vars.default : [],
                    company: Array.isArray(vars.company) ? vars.company : []
                }
            }
            const defaultV = (self.task.variables && Array.isArray(self.task.variables.default)) ? self.task.variables.default : []
            const companyV = (self.task.variables && Array.isArray(self.task.variables.company)) ? self.task.variables.company : []
            const combined = defaultV.concat(companyV).filter(Boolean).map(withNormalizedImages)
            self.variables = combined.length ? { [self.PRODUCT_SLOT_KEY]: combined } : {}
            self.syncVariablesCatalog()
        }).catch(function () {
            self.task.variables = { default: [], company: [] }
            self.variables = {}
        })
    },
    beforeUnmount: function () {
        document.body.classList.remove('no-scroll');
    },
    props: {
        edit: {
            type: Boolean,
            default: false,
        },
        parent_task: {
            type: Object
        },
        breadcrumbSegments: {
            type: Array,
            default: function () { return [] }
        },
        catalogViewMode: {
            type: String,
            default: 'browse'
        },
        isAtCategoryTreeRoot: {
            type: Boolean,
            default: true
        }
    }
  }
</script>
